import { CostDisplay } from '~/components/txn-display/cost-display/CostDisplay'
import { useTransactionCost } from '~/hooks/transactions/useTransactionCost'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'

export const RegularTransactionCostDisplay = ({
  transaction,
}: {
  transaction: OrgRegularTransaction | PublicRegularTransaction
}) => {
  const gasEstimates = {
    callGasLimit: transaction.callGasLimit,
    verificationGasLimit: transaction.verificationGasLimit,
    preVerificationGas: transaction.preVerificationGas,
    maxFeePerGas: transaction.maxFeePerGas,
    maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
  }

  const transactionCost = useTransactionCost({
    isMerkleTransaction: false,
    chainId: transaction.chainId,
    gasEstimates,
  })

  return (
    <CostDisplay
      isLoading={transactionCost.isLoading}
      isSponsored={transaction.isSponsored}
      cost={transactionCost.transactionCost ?? 0}
    />
  )
}
